export default __webpack_public_path__ + "static/media/603ff2c3d11f076b92242695_image-2-teams-technology-template.92ae1ed2.svg";